import { render, staticRenderFns } from "./SAccNavigation.vue?vue&type=template&id=ebdb7c9a&scoped=true"
import script from "./SAccNavigation.vue?vue&type=script&lang=ts"
export * from "./SAccNavigation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebdb7c9a",
  null
  
)

export default component.exports